import { CircularProgress, Divider } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Createcontact } from '../Redux/Action/ContactAction';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import useTitle from '../Hooks/useTitle';

const ContactUs = () => {
    useTitle('Contact Us')
    const { t } = useTranslation('contact_us');
    const dispatch = useDispatch();
    const {  loading } = useSelector((state) => state.Contact)
    const [input, setinput] = useState({
        first_name: '',
        last_name: '',
        email: '',
        message: ''
    })

    const handlesubmit = (e) => {
        e.preventDefault();
        if (!input.first_name || !input.last_name || !input.email || !input.message) {
            toast.error(t("toast_error"));
            return;
        }
        else {
            dispatch(Createcontact(input.first_name, input.last_name, input.email, input.message))
                .then(() => {
                    toast.success(t("toast_submit"))
                })
                .catch((error) => {
                    toast.error(error.code || t("toast_error"))
                })
        }
        setinput({
            first_name: '',
            last_name: '',
            email: '',
            message: '',
        });
    }

    const handlecancel = (e) => {
        e.preventDefault();
        setinput({
            first_name: '',
            last_name: '',
            email: '',
            message: '',
        });
    }

    return (
        <>
            <div className="grid gap-6  p-8 py-6   mt-[76px] sm:ml-[300px]">
                <div className=" items-center z-[1] ">
                    <span className='font-[600] text-[26px]'>{t('header')}</span>
                </div>
                {
                    loading ?
                        (
                            <div className="w-full h-[calc(100vh-290px)] flex justify-center items-center">
                                <CircularProgress size="3rem" />
                            </div>
                        ) :
                        (
                            <form className=' bg-white py-6  flex flex-col rounded-[20px]' method='POST' onSubmit={handlesubmit}>
                                <div className=" grid gap-5 ">

                                    <span className='text-[18px] font-[600] text-[#131415] px-6'>{t('need_help')}</span>

                                    <Divider sx={{ marginTop: 1 }} />
                                    <p className='text-[#131415] flex items-center font-[500] text-[15px] px-6'>{t('description')}</p>
                                    <div className="div w-full grid grid-cols-1  md:grid-cols-2 gap-5 px-6 ">

                                        <div className="flex flex-col gap-2">
                                            <span className='text-[14px] font-[500] text-[#131415] text-left'>{t('first_name_label')}</span>
                                            <input type='text' placeholder={t('placeholder_first_name')} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-2 text-[14px] w-full'
                                                name='first_name'
                                                value={input.first_name}
                                                onChange={(e) => setinput({
                                                    ...input, [e.target.name]: e.target.value
                                                })}
                                            ></input>
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t('last_name_label')}</span>
                                            <input type='text' placeholder={t('placeholder_last_name')} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                name='last_name'
                                                value={input.last_name}
                                                onChange={(e) => setinput({
                                                    ...input, [e.target.name]: e.target.value
                                                })}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="div w-full grid grid-cols-1 px-6 ">

                                        <div className="flex flex-col gap-2">
                                            <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t('email_label')} </span>
                                            <input type='email' placeholder={t('placeholder_email')} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                name='email'
                                                value={input.email}
                                                onChange={(e) => setinput({
                                                    ...input, [e.target.name]: e.target.value
                                                })}
                                            ></input>
                                        </div>

                                    </div>
                                    <div className="div w-full grid grid-cols-1 px-6 ">

                                        <div className="flex flex-col gap-2">
                                            <span className='text-[14px] font-[500]  text-[#131415] text-left'>{t('message_label')} </span>
                                            <textarea id="w3review" name="message" rows="7" placeholder={t('placeholder_message')} className='border border-[#c3cbd7] py-[10px] rounded-[10px] px-3 text-[14px] w-full'
                                                value={input.message}
                                                onChange={(e) => setinput({
                                                    ...input, [e.target.name]: e.target.value
                                                })}
                                            ></textarea>
                                        </div>

                                    </div>
                                    <Divider sx={{ marginTop: 2, marginBottom: 0 }} />
                                    <div className='px-6 flex justify-end gap-3 '>
                                        <button className='text-[#3686FF]  rounded-lg py-[12px] text-[14px] w-full max-w-40' style={{ border: '1px solid #3686FF' }} onClick={handlecancel}>{t('cancel_button')}</button>
                                        <button className='bg-[#3686FF] text-white rounded-lg  py-[12px] text-[14px] w-full max-w-40' >{t('submit_button')}</button>

                                    </div>
                                </div>
                            </form>
                        )
                }
            </div>
        </>
    )
}

export default ContactUs;